<template>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                  
                        

                                <form @submit.prevent="save" v-if="entity">
                                    <div class="row">
                                          <div class="col-12">

                                              <div class="form-group">
                                                    <label class="col-form-label" for="descrizione">Posizione</label>
                                                    <input type="number"  placeholder="Posizione" v-model.number="entity.position" class="form-control" :class="classes">
                                                    <!--<span :class="classes">{{ errors[0] }}</span>-->
                                              </div>
                                        </div>
                                          <div class="col-12">

                                              <div class="form-group">
                                                    <label class="col-form-label" for="descrizione">Descrizione</label>
                                                    <input type="text" id="descrizione" name="descrizione" placeholder="Nome" v-model="entity.name" class="form-control" :class="classes">
                                                    <!--<span :class="classes">{{ errors[0] }}</span>-->
                                              </div>
                                        </div>
                                      <div class="col-12">
                                       <v-select placeholder="Seleziona banca di riferimento" label="name" :multiple="true"  index="companyId" v-model="entity.enableCompanies"  :options="cuser.companies"></v-select>
                                      </div>

                                    </div>




                                        <div class="form-group mt-3">
                                            <button type="button" class="btn btn-xs  btn-primary-rgba mr-2" v-on:click="save">Salva  <font-awesome-icon :icon="['far','save']"></font-awesome-icon></button>
                                            <button type="button" class="btn btn-xs  btn-danger-rgba  mr-2" v-on:click="cancel">Annulla  <font-awesome-icon :icon="['far','times-circle']"></font-awesome-icon></button>
                                        </div>
</form>
                               
                        
                
                </div>
            </div>
        </div>
       
    </div>


</template>

<script>
import vueselect from 'vue-select'
    import Editor from '@tinymce/tinymce-vue'
    import axios from 'axios'
    import { Chrome } from 'vue-color';
 
    export default {
        data() {
            return {
                entity: null,
                colors: '#FFFFFF',
               
            };
        },
        computed: {
          
    cuser() {
      return this.$store.state.user;
    },
            tinyKey: function () {
                return window.SETTINGS.TinyApiKey;
            }
        },
        components: {
            Editor,vueselect
        },
        name: 'TemplateCategorySave',
        beforeMount() {
            this.loaddata();


        },
        methods: {
            loaddata(){
var me = this;
            axios.get("templatecategory/" +( me.$route.params.id ||'')).then(response => {
               response.data.enableCompanies = response.data.enableCompanies.filter(x=>x!="*");
               response.data.enableStates = response.data.enableStates.filter(x=>x!="*");
                                if( response.data.enableCompanies.length == 0)  response.data.enableCompanies = null;
                                me.entity = response.data;
                                if(me.entity.name && me.entity.name!=''){
 me.$store.state.breadCrump.title = me.entity.name;

                                }
            });


            },
            cancel() {
                this.$router.push({
                    name: "route-templatecategory-list",

                    replace: true
                });
            },
           
              updateFromPicker(color) {
                this.entity.backgroundColor = color.hex;
            },
            save() {
                
                let me = this;
                if(this.entity.enableCompanies==null || this.entity.enableCompanies.length ==0){
                    this.entity.companies ="*";
                }else{
                   
                    this.entity.companies = this.entity.enableCompanies.join(",");
                   
                }
               
                 if(this.entity.companies == "")
                        this.entity.companies ="*";
                axios.post("templatecategory", this.entity).then(response => {
                    if (me.$route.params.id != response.data.templateCategoryId) { me.$router.push({ name: 'route-templatecategory-edit', params: { id: response.data.templateCategoryId } }); }

                    me.$swal(
                                    {
                                        title: "Salvataggio avvenuto correttamente",
                                        text: "",
                                        type: "success",
                                        showCancelButton: false,
                                        toast: true,
                                        timer: 2000,
                                        showConfirmButton: false,
                                        position: "bottom-top"
                        });
                })
            }
        }
    };
</script>
